import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

/** Data contract for the generic confirm dialog — header, body copy and CTA label. */
export interface ConfirmStatusChangeDialogData {
  header: string;
  message: string;
  confirmLabel: string;
  /** Cancel/safe-option label — defaults to "Cancel" (e.g. "Keep active" for a deactivate gate, R-BTN-02). */
  cancelLabel?: string;
}

/**
 * Generic confirmation dialog used to gate a status change behind an explicit
 * "Yes / Cancel" decision. Closes with `true` on confirm, `false`/undefined otherwise.
 * Introduced for the admin "mark past event complete/cancelled" flow (#494).
 */
@Component({
  selector: 'bodyanalytics-confirm-status-change-dialog',
  imports: [MatDialogModule],
  templateUrl: './confirm-status-change-dialog.component.html',
  styleUrls: ['./confirm-status-change-dialog.component.scss'],
})
export class ConfirmStatusChangeDialogComponent {
  protected data = inject<ConfirmStatusChangeDialogData>(MAT_DIALOG_DATA);
}
